module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-container",
    on: {
      "keyup": function($event) {
        _vm.keyUp($event)
      }
    }
  }, [(_vm.drawer) ? _c('div', {
    staticClass: "nav-overlay animated fadeIn",
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "nav-menu",
    class: _vm.drawer ? 'active' : ''
  }, [_c('button', {
    staticClass: "nav-control",
    attrs: {
      "aria-label": _vm.drawer ? 'Cerrar menú de navegación' : 'Abrir menú de navegación',
      "aria-hidden": "",
      "aria-expanded": _vm.drawer ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.openNav()
      }
    }
  }, [(!_vm.drawer) ? _c('v-icon', [_vm._v("fa-bars")]) : _vm._e(), _vm._v(" "), (_vm.drawer) ? _c('v-icon', [_vm._v("fa-times")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-title"
  }, [_vm._v("\n      Administración del dinero\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-list",
    attrs: {
      "aria-hidden": _vm.drawer ? false : true
    }
  }, [_c('ul', {
    attrs: {
      "aria-label": "listado de temas"
    }
  }, _vm._l((_vm.menubots), function(item, index) {
    return (item.visto) ? _c('li', {
      key: item.name,
      attrs: {
        "id": 'nav-item-' + index
      }
    }, [_c('router-link', {
      class: {
        'router-link-active': item.active
      },
      attrs: {
        "tabindex": _vm.drawer ? 0 : -1,
        "aria-label": item.name,
        "to": item.link
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickNav,
          _vm.hideNav()
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])], 1) : _vm._e()
  })), _vm._v(" "), _c('button', {
    attrs: {
      "aria-label": "Cerrar menú de navegación"
    },
    on: {
      "click": function($event) {
        _vm.drawer = false
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c07d6c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Menunav.vue
// module id = 951
// module chunks = 1